export default {"src":"/_next/static/media/papua-new-guinea.fe9eee4e.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};